import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pencil, Trash2, X, PlusCircle } from 'lucide-react';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const Bank = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;

  const NProgressSpinner = () => (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      <div
        style={{
          boxSizing: "border-box",
          display: "block",
          width: "40px",
          height: "40px",
          border: "4px solid #29d",
          borderRadius: "50%",
          borderTopColor: "transparent",
          animation: "spin 0.6s linear infinite",
          margin: "0 auto 10px"
        }}
      ></div>
      <div>Memuat data...</div>
    </div>
  );

  useEffect(() => {
    // Ambil data dari localStorage
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/login"); // Jika tidak ada user, arahkan ke login
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const [data, setData] = useState([]);

  const [pending, setPending] = useState(true);
  const [editData, setEdit] = useState(null);
  const [addData, setAdd] = useState(null); 
  const [formData, setFormData] = useState({ name: '', pic: '' });
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/bank`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data);
        setPending(false);
      });
  };

  const filteredData = data.filter((item) =>
  item.bank.toLowerCase().includes(searchText.toLowerCase()) ||
  item.atas_nama.toLowerCase().includes(searchText.toLowerCase()) || item.no_rek.toLowerCase().includes(searchText.toLowerCase()) || item.cabang.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleEdit = (bank) => {
    setEdit(bank);
    setFormData({ bank: bank.bank,atas_nama: bank.atas_nama,no_rek: bank.no_rek,cabang: bank.cabang,updated_by: email,});
  };

  const handleAdd = (bank) => {
    setAdd(bank);
    setFormData({ bank: bank.bank,atas_nama: bank.atas_nama,no_rek: bank.no_rek,cabang: bank.cabang, });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/bank/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Data berhasil dihapus.', 'success');
            fetchData();
          });
      }
    });
  };


  const handleUpdate = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_BASE_URL}api/bank/${editData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then(() => {
        Swal.fire({
          toast: true,
          position: 'top',
          icon: 'success',
          title: 'Success',
          text: "Data Akun Bank berhasil diperbarui",
          showConfirmButton: false,
          showCloseButton: true,  
          timer: 300000,
          timerProgressBar: true,
        });
        setEdit(null);
        fetchData();
      });
  };

  const handleInsert = async (e) => {
  e.preventDefault();

  try {
        // 1. Ambil semua event dulu
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/bank`);
        const json = await response.json();
        const existingEvents = json.data;

        // 2. Cek apakah nama sudah ada (case-insensitive)
        const isDuplicate = existingEvents.some(
        (bank) => bank.no_rek.toLowerCase() === formData.no_rek.toLowerCase()
        );

        if (isDuplicate) {
        // 3. Tampilkan error jika duplikat
        Swal.fire({
            icon: 'error',
            title: 'Gagal Menyimpan',
            text: 'No.Rekening sudah ada. Gunakan No.Rekening lain.',
        });
        return;
        }

        // 4. Lanjutkan menyimpan jika tidak duplikat
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/bank/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
        });

        if (!res.ok) {
        throw new Error('Gagal menyimpan data');
        }

        // 5. Berhasil
        Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Data berhasil disimpan!',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        });
        setAdd(null);
        fetchData(); // refresh data tabel
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Terjadi kesalahan',
        text: error.message || 'Gagal menyimpan data',
      });
    }
  };


  const columns = [
    {
      name: 'Atas Nama',
      selector: row => row.atas_nama,
      sortable: true,
    },
    {
      name: 'Bank',
      selector: row => row.bank,
      sortable: true,
    },
    {
      name: 'No.Rekening',
      selector: row => row.no_rek,
      sortable: true,
    },
    {
      name: 'Cabang',
      selector: row => row.cabang,
      sortable: true,
    },
    {
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-yellow-400 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row)}
          >
            <Pencil size={16} />
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white p-1 rounded"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: '1px solid #ccc', // border luar tabel
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f3f4f6', // bg abu-abu muda
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
      },
    },
    headCells: {
      style: {
        borderRight: '1px solid #ccc',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #ccc',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #eee',
      },
    },
  };


  return (
    <div className="p-2">
      <div className="flex justify-between mb-4 gap-2">
        <button
          className="flex items-center gap-2 border bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
          onClick={handleAdd}>
          <PlusCircle size={16}></PlusCircle> Tambah
        </button>   
          <input
            type="text"
            placeholder="Pencarian..."
            className="border border-gray-300 px-2 py-2 rounded-2xl w-full md:w-1/4"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
             
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        responsive
        progressPending={pending}
        progressComponent={<NProgressSpinner  />}
        highlightOnHover
        striped
        fixedHeader
        customStyles={customStyles}
      />

      {/* Modal Edit */}
      {editData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setEdit(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Edit Data Akun Bank</h3>
            <form onSubmit={handleUpdate} className="space-y-4">
              <div>
                <label className="block font-medium">Atas Nama</label>
                <input
                  type="text"
                  value={formData.atas_nama}
                  onChange={(e) =>
                    setFormData({ ...formData, atas_nama: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Bank</label>
                <input
                  type="text"
                  value={formData.bank}
                  onChange={(e) =>
                    setFormData({ ...formData, bank: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">No.Rekening</label>
                <input
                  type="text"
                  value={formData.no_rek}
                  onChange={(e) =>
                    setFormData({ ...formData, no_rek: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Cabang</label>
                <input
                  type="text"
                  value={formData.cabang}
                  onChange={(e) =>
                    setFormData({ ...formData, cabang: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  onClick={() => setEdit(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {addData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setAdd(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Tambah Akun Bank</h3>
            <form onSubmit={handleInsert} className="space-y-4">
              <div>
                <label className="block font-medium">Atas Nama</label>
                <input
                  type="text"
                  value={formData.atas_nama}
                  onChange={(e) =>
                    setFormData({ ...formData, atas_nama: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Bank</label>
                <input
                  type="text"
                  value={formData.bank}
                  onChange={(e) =>
                    setFormData({ ...formData, bank: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">No.Rekening</label>
                <input
                  type="text"
                  value={formData.no_rek}
                  onChange={(e) =>
                    setFormData({ ...formData, no_rek: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Cabang</label>
                <input
                  type="text"
                  value={formData.cabang}
                  onChange={(e) =>
                    setFormData({ ...formData, cabang: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded-2xl"
                  required
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  onClick={() => setAdd(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bank;
